module.exports = __webpack_public_path__ + "static/media/chez.60e9dd17.png";